import { Modal, Button } from 'react-bootstrap';
import React from 'react';
import SimpleDataTables from '../Common/SimpleDataTables';
const TrackingProductModal = ({ data, show, handleClose }) => {
    console.log('data', data);
    const columns = [
        {
            label: 'Product Id',
            field: 'productId',
        },
        {
            label: 'Name',
            field: 'productName',
        },
        {
            label: 'Description',
            field: 'productDescription',
        },
        {
            label: 'Category',
            field: 'productType',
        },
        {
            label: 'Quantity',
            field: 'productQuantity',
        },
    ];

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Tracking Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {data && data.length === 0 ? (
                    <>
                        <div className="d-flex justify-content-center">
                            <div className="spinner-grow text-primary" role="status">
                            </div>
                        </div>
                        <p className='text-center'>Loading...</p>
                    </>
                ) : <SimpleDataTables columns={columns} rows={data} />}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TrackingProductModal;

